<template>
  <el-dialog :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false" width="95%" top="0px"
             v-loading="loading || loading2 || loading3">
    <el-form label-position="left" ref="AddClassForm" :rules="addClassFormRule" label-width="110px"
             :model="addClassForm">
      <div style="background: #FFFFFF;text-align: center">
        <em class="el-icon-close dialog-close-manual" v-on:click="dialogFormVisible = false"></em>
        <h1 class="acr-dialog-title">添加课程</h1>
        <div style="width: 95%;margin: auto;position: relative;padding-bottom: 60px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="归属课程">
                <el-select v-model="selectedCurriculumId" placeholder="请选择归属课程">
                  <el-option v-for="item in curriculumList" :label="item.name" :value="item.id"
                             :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="归属章节" prop="chapterId">
                <el-select v-model="addClassForm.chapterId" placeholder="请选择归属章节">
                  <el-option v-for="item in chapterList" :label="item.name" :value="item.id"
                             :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="归属分类" prop="classificationId">
                <el-select v-model="addClassForm.classificationId" placeholder="请选择归属分类">
                  <el-option v-for="item in classificationList" :label="item.name" :value="item.id"
                             :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="归属难度" prop="lvlId">
                <el-select v-model="addClassForm.lvlId" placeholder="请选择归属难度">
                  <el-option v-for="item in lvlList" :label="item.name" :value="item.id"
                             :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否开源" prop="openSource">
                <el-select v-model="addClassForm.openSource" placeholder="请选择开源类型">
                  <el-option label="是" value="true"></el-option>
                  <el-option label="否" value="false"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否包含视频" prop="videoType">
                <el-select v-model="addClassForm.videoType" placeholder="请选择文章类型">
                  <el-option label="是" value="true"></el-option>
                  <el-option label="否" value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="课程名" prop="name">
                <el-input v-model="addClassForm.name"></el-input>
              </el-form-item>
              <el-form-item label="视频地址" prop="videoSrc">
                <el-input v-model="addClassForm.videoSrc" :disabled="addClassForm.videoType !== 'true'"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div id="app-curriculum-class-basic-markdown">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item label="文章封面" prop="coverPhoto">
                  <el-input v-model="addClassForm.coverPhoto" disabled></el-input>
                </el-form-item>
                <el-upload class="avatar-uploader" :show-file-list="false" :http-request="uploadFile" action="">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" alt="pic">
                  <em v-else class="el-icon-plus avatar-uploader-icon"></em>
                </el-upload>
                <MarkdownTree :tree-data="navTree" style="text-align: left;max-height: 300px"></MarkdownTree>
              </el-col>
              <el-col :span="20">
                <mavon-editor v-model="bufferContent" ref="md" :style="{height:'560px'}" @imgAdd="handleEditorImgAdd"/>
              </el-col>
              <div style="display: none">
                <MarkdMain v-if="loadTree" :mark-data="addClassForm.content"
                           v-outline=" {callback: refreshNavTree,selectors: ['h1','h2','h3','h4','h5']}"></MarkdMain>
              </div>
            </el-row>
          </div>
          <el-button style="position: absolute;right: 0" v-on:click="AddClass">提交</el-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>

import AxiosBase from "@/components/axiosBase";
import {Message} from "element-ui";
import MarkdMain from "@/views/article/share/components/MarkdMain";
import MarkdownTree from "@/views/article/share/components/MarkdownTree";

export default {
  name: "AddCurriculumClassDialog",
  components: {
    MarkdownTree,
    MarkdMain
  },
  data() {
    const validateVideoSrc = (rule, value, callback) => {
      if (this.addClassForm.videoType === 'true') {
        if (value === '') {
          callback(new Error('请输入视频地址'))
        }
      }
      callback();
    }
    return {
      loading: true,
      loading2: true,
      loading3: true,
      loadTree: true,
      dialogFormVisible: false,
      curriculumList: [],
      selectedCurriculumId: '',
      chapterList: [],
      classificationList: [],
      lvlList: [],
      addClassForm: {
        chapterId: '',
        classificationId: '',
        lvlId: '',
        openSource: '',
        videoType: '',
        name: '',
        videoSrc: '',
        coverPhoto: '',
        content: ''
      },
      addClassFormRule: {
        chapterId: [
          {required: true, message: '请选择归属章节', trigger: 'change'}
        ],
        classificationId: [
          {required: true, message: '请选择归属分类', trigger: 'change'}
        ],
        lvlId: [
          {required: true, message: '请选择归属难度', trigger: 'change'}
        ],
        openSource: [
          {required: true, message: '请选择是否开源', trigger: 'change'}
        ],
        videoType: [
          {required: true, message: '请选择文章类型', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入课程名', trigger: 'blur'},
          {min: 2, max: 32, message: '请输入正确长度的课程名[2-32]', trigger: 'blur'}
        ],
        videoSrc: [
          {validator: validateVideoSrc, trigger: 'blur'}
        ],
        coverPhoto: [
          {required: true, message: '请上传课程封面', trigger: 'blur'}
        ]
      },
      imageUrl: '',
      bufferContent: '',
      navTree: []
    }
  },
  watch: {
    selectedCurriculumId(newVal) {
      this.loading = true;
      AxiosBase.axiosGet("/curriculum-ad/get-curriculum-chapter", {
        params: {
          key: newVal
        }
      }).then(response => {
        if (response !== 0) {
          this.chapterList = response.data;
          this.loading = false;
        }
      })
    },
    bufferContent(newVal) {
      if (newVal === '') {
        this.navTree = [];
        this.addClassForm.content = '';
      } else {
        this.loadTree = false;
        setTimeout(() => {
          this.loadTree = true
        }, 1)
        this.addClassForm.content = newVal;
      }
    },
  },
  methods: {
    enterAddClass() {
      this.loading = true;
      this.loading2 = true;
      this.loading3 = true;
      AxiosBase.axiosGet("/curriculum-ad/get-curriculum-list").then(response => {
        if (response !== 0) {
          this.curriculumList = response.data;
          this.loading = false;
        }
      })
      AxiosBase.axiosGet("/curriculum-ad/get-classification").then(response => {
        if (response !== 0) {
          this.classificationList = response.data;
          this.loading2 = false;
        }
      })
      AxiosBase.axiosGet("/curriculum-ad/get-lvl").then(response => {
        if (response !== 0) {
          this.lvlList = response.data;
          this.loading3 = false;
        }
      })
    },
    AddClass() {
      this.$refs['AddClassForm'].validate((valid) => {
        if (valid) {
          if (this.addClassForm.content.length !== 0) {
            AxiosBase.axiosPut("/curriculum-ad/add-curriculum-class", this.addClassForm).then(response => {
              if (response !== 0) {
                this.$parent.$parent.getClassData();
                this.$refs['AddClassForm'].resetFields();
                this.imageUrl = '';
                this.dialogFormVisible = false;
                Message({
                  showClose: true,
                  message: '添加课程成功',
                  type: 'success'
                });
              }
            })
          } else {
            Message({
              showClose: true,
              message: '请输入文章内容',
              type: 'error'
            });
          }
        }
      });
    },
    handleEditorImgAdd(pos, $file) {
      const formData = new FormData();
      formData.append('file', $file);
      AxiosBase.axiosPost('/ff/upload-admin', formData).then(response => {
        if (response !== 0) {
          this.$refs.md.$imglst2Url([[pos, "https://img.blendermagic.cn/admin/" + response.data]])
        }
      })
    },
    uploadFile(fileObj) {
      let formData = new FormData();
      formData.set("file", fileObj.file);
      AxiosBase.axiosPost("/ff/upload-admin", formData, {
        headers: {
          "Content-type": "multipart/form-data"
        }
      }).then(response => {
        if (response !== 0) {
          const imgPath = "https://img.blendermagic.cn/admin/" + response.data
          this.addClassForm.coverPhoto = imgPath;
          this.imageUrl = imgPath;
        }
      })
    },
    refreshNavTree(treeData) {
      if (treeData !== undefined && treeData.length !== 0) {
        this.navTree = treeData.splice(0, 1)
      } else {
        this.navTree = []
      }
    },
  }
}
</script>

<style scoped>

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 241px;
  height: 157px;
  line-height: 170px;
  text-align: center;
}

.avatar {
  width: 241px;
  height: 157px;
  display: block;
}

#app-curriculum-class-basic-markdown {
  margin-top: 10px;
  margin-bottom: 5px;
}

</style>